var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{style:(_vm.style)},[_c('v-textarea',_vm._b({model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-textarea',_vm.textareaAttrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }